module.exports = __webpack_public_path__ + "img/desktop.49d98e1f.svg";